import React, { useState } from 'react';

const AudioMessage = ({ src, duration }) => {
   const [failed, setFailed] = useState(false);
   if (!src) return null;
   if (failed) return <div className='chatterbox-media-error'>Media could not be loaded.</div>;

   return (
      <div className='chatterbox-media'>
         <audio controls src={src} onError={() => setFailed(true)} />
         {duration != null && <span className='chatterbox-media-duration'>{duration}s</span>}
      </div>
   );
};

export default AudioMessage;
